import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Coffee, Home, Sparkles, Utensils } from 'lucide-react';
export function Story() {
  return <section className="py-16 bg-white" data-id="element-200">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl" data-id="element-201">
        {/* The emotional opening */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center" data-id="element-202">
          <h2 className="text-3xl font-bold text-brown-900 mb-6" data-id="element-203">
            ¿Cuántas veces sentiste que el dinero no alcanza?
          </h2>

          <p className="text-lg text-brown-800/80 mb-6" data-id="element-204">
            Trabajas, te esforzás, te organizás…{' '}
            <span className="font-medium text-brown-900" data-id="element-205">
              pero las cuentas siguen llegando.
            </span>{' '}
            Y en silencio te preguntás:
          </p>

          <blockquote className="border-l-4 border-burgundy-500 pl-5 py-2 my-6 bg-cream-50 rounded-r-lg italic font-medium text-brown-900 text-left max-w-xl mx-auto" data-id="element-206">
            “¿Habrá alguna manera REAL de generar ingresos desde casa sin
            depender completamente de un empleo?”
          </blockquote>

          <p className="text-lg text-brown-800/80 mb-4" data-id="element-207">
            La mayoría cree que para emprender necesita:
          </p>
          <div className="flex flex-wrap justify-center gap-2 mb-8" data-id="element-208">
            {['Mucho dinero', 'Experiencia', 'Un local elegante', 'Contactos', 'Conocimientos avanzados'].map(item => <span key={item} className="inline-flex items-center gap-1.5 bg-cream-100 text-brown-800 px-3 py-1.5 rounded-full text-sm border border-cream-200" data-id="element-209">
                <span className="text-burgundy-500" data-id="element-210">❌</span> {item}
              </span>)}
          </div>

          <p className="font-bold text-xl text-burgundy-600 mb-3" data-id="element-211">
            Pero eso no es verdad.
          </p>
          <p className="text-brown-800/80 max-w-xl mx-auto" data-id="element-212">
            Hoy existe una oportunidad mucho más simple, que podría empezar
            literalmente en tu cocina. Y tiene un aroma irresistible.
          </p>
          <h3 className="text-3xl font-bold text-brown-900 mt-6" data-id="element-213">
            Budines caseros.
          </h3>
        </motion.div>

        {/* El negocio que muchos están ignorando */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="mt-16" data-id="element-214">
          <h2 className="text-3xl font-bold text-brown-900 text-center mb-6" data-id="element-215">
            El negocio que muchos están ignorando
          </h2>

          <p className="text-lg text-brown-800/80 text-center max-w-2xl mx-auto mb-6" data-id="element-216">
            Mientras algunos persiguen negocios complicados, otras personas
            generan ingresos con algo mucho más humano. Porque un budín NO es
            solo comida.
          </p>

          <div className="grid grid-cols-2 sm:grid-cols-5 gap-3 max-w-3xl mx-auto bg-cream-50 p-5 rounded-2xl border border-cream-200" data-id="element-217">
            <div className="flex flex-col items-center text-center gap-2" data-id="element-218">
              <Coffee className="text-brown-800 w-6 h-6" data-id="element-219" />
              <span className="text-sm font-medium" data-id="element-220">una merienda</span>
            </div>
            <div className="flex flex-col items-center text-center gap-2" data-id="element-221">
              <Home className="text-brown-800 w-6 h-6" data-id="element-222" />
              <span className="text-sm font-medium" data-id="element-223">olor a hogar</span>
            </div>
            <div className="flex flex-col items-center text-center gap-2" data-id="element-224">
              <Heart className="text-burgundy-500 w-6 h-6" data-id="element-225" />
              <span className="text-sm font-medium" data-id="element-226">cariño</span>
            </div>
            <div className="flex flex-col items-center text-center gap-2" data-id="element-227">
              <Sparkles className="text-gold-500 w-6 h-6" data-id="element-228" />
              <span className="text-sm font-medium" data-id="element-229">momento especial</span>
            </div>
            <div className="flex flex-col items-center text-center gap-2" data-id="element-230">
              <Utensils className="text-brown-800 w-6 h-6" data-id="element-231" />
              <span className="text-sm font-medium" data-id="element-232">placer instantáneo</span>
            </div>
          </div>

          <p className="text-center mt-6 font-medium text-lg text-brown-900" data-id="element-233">
            Por eso las personas vuelven a comprar una y otra vez.
          </p>
        </motion.div>

        {/* La verdad sobre vender budines */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="mt-16 bg-burgundy-600 text-white rounded-3xl p-8 sm:p-10 shadow-xl relative overflow-hidden" data-id="element-234">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-5 rounded-full -translate-y-1/2 translate-x-1/3" data-id="element-235"></div>

          <h2 className="text-3xl font-bold mb-4 relative z-10 text-center" data-id="element-236">
            La verdad sobre vender budines
          </h2>

          <p className="text-center text-white/90 mb-6 relative z-10" data-id="element-237">
            No necesitas ser chef profesional, ni abrir una cafetería, ni
            invertir miles de pesos.
          </p>

          <div className="bg-white/10 rounded-2xl p-5 backdrop-blur-sm relative z-10 max-w-md mx-auto" data-id="element-238">
            <p className="font-bold mb-4 text-center" data-id="element-239">
              Lo que realmente necesitas:
            </p>
            <ul className="space-y-2" data-id="element-240">
              <li className="flex items-start gap-2" data-id="element-241">
                <span className="text-gold-400" data-id="element-242">✅</span>
                <span data-id="element-243">Una receta irresistible</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-244">
                <span className="text-gold-400" data-id="element-245">✅</span>
                <span data-id="element-246">Una presentación atractiva</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-247">
                <span className="text-gold-400" data-id="element-248">✅</span>
                <span data-id="element-249">Un método simple para conseguir clientes</span>
              </li>
            </ul>
          </div>

          <p className="text-center mt-6 relative z-10" data-id="element-250">
            Eso es exactamente lo que aprenderás dentro de:
          </p>
          <h3 className="text-2xl sm:text-3xl font-bold text-center mt-2 text-gold-400 font-serif relative z-10" data-id="element-251">
            “Del Horno a Tu Primer Ingreso”
          </h3>
        </motion.div>

        {/* Imagina esto por un momento... */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="mt-16" data-id="element-252">
          <h2 className="text-3xl font-bold text-brown-900 text-center mb-3" data-id="element-253">
            Imagina esto por un momento…
          </h2>
          <p className="text-center text-brown-800/80 mb-6" data-id="element-254">
            Tu horno encendido, el aroma dulce llenando la casa, y tu celular
            vibrando constantemente:
          </p>

          <div className="flex flex-col gap-3 max-w-sm mx-auto mb-6" data-id="element-255">
            <div className="bg-green-50 border border-green-200 rounded-2xl rounded-tl-none p-3 text-left shadow-sm" data-id="element-256">
              <span className="text-green-800 font-medium" data-id="element-257">
                “¿Todavía te quedan?”
              </span>
            </div>
            <div className="bg-green-50 border border-green-200 rounded-2xl rounded-tr-none p-3 text-right shadow-sm ml-auto" data-id="element-258">
              <span className="text-green-800 font-medium" data-id="element-259">
                “¿Me guardás dos?”
              </span>
            </div>
            <div className="bg-green-50 border border-green-200 rounded-2xl rounded-tl-none p-3 text-left shadow-sm" data-id="element-260">
              <span className="text-green-800 font-medium" data-id="element-261">
                “Necesito tres para mañana.”
              </span>
            </div>
          </div>

          <p className="font-handwriting text-3xl text-burgundy-600 text-center" data-id="element-262">
            Algo pequeño puede convertirse en algo grande.
          </p>
        </motion.div>
      </div>
    </section>;
}